import(/* webpackMode: "eager" */ "/app/src/app/[locale]/maintenance-support/page.tsx");
